import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.reduce";
export var getColumns = function getColumns(_ref) {
  var columns = _ref.columns,
      data = _ref.data;
  return columns || (data[0] ? Object.keys(data[0]).reduce(function (acc, cell) {
    acc.push({
      content: cell,
      key: cell
    });
    return acc;
  }, []) : []);
};
export var getComparators = function getComparators(_ref2) {
  var columns = _ref2.columns;
  var comparators = columns && columns.reduce(function (acc, column) {
    var key = column.key,
        sortComparator = column.sortComparator;

    if (sortComparator) {
      acc[key] = sortComparator;
    }

    return acc;
  }, {});
  return comparators && Object.keys(comparators).length ? comparators : undefined;
};
export var getSelectableRows = function getSelectableRows(rows) {
  return rows.filter(function (row) {
    return !row.disabled;
  });
};
export var getSortable = function getSortable(_ref3) {
  var columns = _ref3.columns,
      defaultSort = _ref3.defaultSort,
      sort = _ref3.sort,
      sortable = _ref3.sortable;
  return Boolean(defaultSort || sort || sortable || columns && columns.some(function (column) {
    return column.sortable;
  }));
};